<template>
    <div class="link-analytics-correctness" @click="routeAnalyticsCorrectness">
        <span class="link-analytics-correctness__heading">Doğruluk</span>
        <span class="link-analytics-correctness__text">Pratiklerde ne kadar başarılı olduğunu incele</span>
        <span class="link-analytics-correctness__art-pattern--left"></span>
        <span class="link-analytics-correctness__art-pattern--right"></span>
        <span class="link-analytics-correctness__art-bullseye"></span>
    </div>
</template>
<script>
    export default {
        methods: {
            routeAnalyticsCorrectness(){
                this.$router.push('/analytics/correctness');
            }
        }
    };
</script>
<style scoped src="@/css/components/link-analytics-correctness.css"></style>